<modal [title]="title">
    <div>
        <p class="text">Bien sûr, on ne va pas vous laisser comme ça&nbsp;!</p>
        <p class="text">Nous vous invitions à réaliser votre commande en boutique auprès d'un conseiller.</p>
    </div>

    <ng-template #customModalFooter>
        <div class="buttons">
            <button class="button is-loaded is-secondary" (click)="close()">Fermer</button>
            <button class="button is-loaded is-conversion" (click)="redirectToStore()">Rendez-vous en boutique</button>
        </div>
    </ng-template>
</modal>
